import React from 'react';
import NavbarNoLogin from './NavBarNoLogin';
import Footer from './Footer';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"

const LayoutNoLogin = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-base-200">
      <NavbarNoLogin />
      <main className="flex-grow container mx-auto px-4 py-6 md:px-8 lg:px-12">
        <div>
          {children}
        </div>
      </main>
      <Analytics />
      <SpeedInsights />
      <Footer />
    </div>
  );
};

export default LayoutNoLogin;
